import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import Button from "@components/ButtonComponent";
import { DollarSign } from "lucide-react";

const CashPositionSection = ({
  selectedOutlets,
  getSelectedOutletDetails,
  handleCashPositionClick,
  isCashPositionModalOpen,
  setIsCashPositionModalOpen,
}) => {
  if (selectedOutlets.length === 0) {
    return null;
  }

  return (
    <Dialog
      open={isCashPositionModalOpen}
      onOpenChange={setIsCashPositionModalOpen}
    >
      <DialogTrigger asChild>
        <Button
          color="green"
          size="xs"
          width="max"
          icon={<DollarSign className="w-4 h-4" />}
          noTextSwap={true}
        >
          {`Cash Position`}
        </Button>
      </DialogTrigger>
      <DialogContent className="max-w-md bg-white">
        <DialogHeader>
          <DialogTitle>{`Select Outlet for Cash Position`}</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          {getSelectedOutletDetails().map((outlet) => (
            <div
              key={outlet.id}
              className="flex items-center justify-between p-3 dark:bg-gray-700 bg-gray-50 rounded-lg"
            >
              <div>
                <p className="font-medium dark:text-white text-gray-900">{outlet.name}</p>
                <p className="text-sm dark:text-white text-gray-600">{outlet.code}</p>
              </div>
              <Button
                size="sm"
                width="max"
                onClick={() =>
                  handleCashPositionClick(outlet.id, outlet.name)
                }
              >
                {`Cash Position`}
              </Button>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default CashPositionSection;
